import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { id: "column-wide-remove" }, [
      _createElementVNode("path", {
        id: "vector",
        d: "M1.66699 13H1.16699V13.5H1.66699V13ZM1.66699 3V2.5H1.16699V3H1.66699ZM8.00033 13V13.5H8.50033V13H8.00033ZM14.3337 3H14.8337V2.5L14.3337 2.5V3ZM13.8337 7.66667V8.16667H14.8337V7.66667H13.8337ZM8.00033 3V2.5V3ZM11.3539 9.31311L11.0003 8.95956L10.2932 9.66667L10.6468 10.0202L11.3539 9.31311ZM13.9801 13.3536L14.3337 13.7071L15.0408 13L14.6872 12.6464L13.9801 13.3536ZM10.6468 12.6464L10.2932 13L11.0003 13.7071L11.3539 13.3536L10.6468 12.6464ZM14.6872 10.0202L15.0408 9.66667L14.3337 8.95956L13.9801 9.31311L14.6872 10.0202ZM2.16699 13V3H1.16699V13H2.16699ZM8.00033 12.5H1.66699V13.5H8.00033V12.5ZM13.8337 3V7.66667H14.8337V3H13.8337ZM1.66699 3.5H8.00033V2.5H1.66699V3.5ZM8.00033 3.5L14.3337 3.5V2.5L8.00033 2.5V3.5ZM8.50033 13V3H7.50033V13H8.50033ZM10.6468 10.0202L12.3134 11.6869L13.0205 10.9798L11.3539 9.31311L10.6468 10.0202ZM12.3134 11.6869L13.9801 13.3536L14.6872 12.6464L13.0205 10.9798L12.3134 11.6869ZM11.3539 13.3536L13.0205 11.6869L12.3134 10.9798L10.6468 12.6464L11.3539 13.3536ZM13.0205 11.6869L14.6872 10.0202L13.9801 9.31311L12.3134 10.9798L13.0205 11.6869Z",
        fill: "#7F7F83"
      })
    ], -1)
  ])))
}
export default { render: render }